/*
 * @Author: duke
 * @Date: 2024-04-19 16:15:23
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { i18n, keys } from '@/lang'
import store from '@/store'
import { getLogin } from '@/utils/account'
import { createApplication } from "@/utils/host_application";
import { isMacOS } from '@/utils/platform'

const app = createApplication()

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: "/login",
    component: () => import("@/views/login/LoginPage.vue")
  },
  {
    path: "/",
    component: () => import("@/views/Layout"),
    children: [
      {
        path: '/workbench',
        name: 'workbench',
        meta: {
          title: 'routes.workbench',
          keepAlive: false
        },
        component: (resolve) => require(['../views/workbench/Workbench.vue'], resolve)
      },
      {
        path: '/printerList',
        name: 'printerList',
        meta: { keepAlive: false },
        component: () => import('@/views/printerList/printerList.vue')
      },
      {
        path: '/cloudSpace',
        name: 'cloudSpace',
        meta: { keepAlive: true },
        component: () => import('@/views/cloudSpace/cloudSpace.vue')
      },
      {
        path: '*',
        redirect: '/workbench',
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_BASE_URL,
  routes
})
// 挂载路由导航守卫
router.beforeEach(async (to, from, next) => {
  /**
   * @description: 国际化切换--url
   * @param language 需要对应的国际化key才生效,默认中文简体
   */
  if (Object.keys(keys).find((i) => i = to.query?.language)) {
    localStorage.setItem('language', to.query.language)
    i18n.locale = to.query.language
  }
  // if (to.query?.isDark == 1) {
  //   store.commit('SET_IS_DARK', true)
  // } else if (to.query?.isDark == 0) {
  //   store.commit('SET_IS_DARK', false)
  // }
  // 生产或者测试环境
  if (to.query?.prod) {
    localStorage.setItem('prod', to.query.prod)
  }
  //  判断是否国外环境
  if (to.query?.regionCn) {
    localStorage.setItem('regionCn', to.query.regionCn)
  }
  // 自动登录逻辑更新token
  if (to.path != "/login") {
    await getLogin(true)
  }
  const res = await app.config_read('machine_list_of_LAN')
  const list = res ? JSON.parse(res) : []
  store.dispatch('GET_LAN_PRINTER_LIST_SLICE')

  // 获取token  
  const tokenStr = store.getters.GET_TOKEN
  // 无需登录白名单
  const whiteList = ["/login"];
  if (tokenStr) {
    if (to.path === "/login") {
      next("/workbench");
    } else {
      next();
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else if (list?.length > 0) {
      if (to.path == "/cloudSpace" && !tokenStr) {
        next("/workbench");
      } else {
        next();
      }

    }
    /**
     * @description: cardoor相关
     */
    // else if (to.query?.code) {
    //     store.dispatch('GET_OAUTH_TOKEN', to.query)
    //     next(`/login${location.search}`);
    // }
    else {
      next('/login')
    }
  }
})


export default router